var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"microsoft-callback"},[_c('div',{staticClass:"callback-card"},[_c('h5',{staticClass:"mb-2"},[_vm._v("Microsoft Sign-In")]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }